(function () {
	'use strict';

	angular.module('qbePortal').controller('MultiselectDropdown', MultiselectDropdown);

	MultiselectDropdown.$inject = ['$scope', 'serviceResponseRepository', 'quoteModelFactory', 'labelService'];

	function MultiselectDropdown($scope, serviceResponseRepository, quoteModelFactory, labelService) {
		var vm = this;

		vm.ls = labelService;

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({name: name, setHierarchyFn: setHierarchyFn});
		}

		vm.onValueChanged = function (event) {

			if (!!vm.fieldValue) {
				if (vm.selectedOptions.indexOf(vm.fieldValue) == -1) {
					vm.selectedOptions.push(vm.fieldValue);
				}
				vm.fieldValue = '';
			}

		}

		vm.getLabelFor = function (value) {
			var label = '';

			for (var item in vm.options) {
				if (vm.options[item].value == value) {
					label = vm.options[item].label;
				}
			}
			return label;
		}

		vm.removeItem = function (item) {
			if (vm.selectedOptions.length <= 1) {
				vm.selectedOptions = [];
			} else {
				var index = vm.selectedOptions.indexOf(item);
				vm.selectedOptions.splice(index, 1);
			}

		}

		vm.getOptions = function () {
			return vm.options;
		}

	}

	angular.module('qbePortal').component('multiselectDropdown', {
		templateUrl: '../ngviews/components/qbMultiselectDropdown.html',
		controller: MultiselectDropdown,
		controllerAs: 'vm',
		bindings: {
			name: '@',
			update: '&',
			setHierarchy: '&',
			validationSelector: '@',
			fieldValue: '<',
			options: '<',
			selectedOptions: '=',
			labelWildcard: '<',
			selectionLimit: '<'
		}
	});
})();
